import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tabs,
  Tab,
} from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import CircularProgress from '@mui/material/CircularProgress';

import CustomHeader from '../../components/common/header/CustomHeader';
import Sidebar from '../../components/common/sidebar/Sidebar';
import OpaqueLoading from '../../components/common/opaqueLoading/opaqueLoading';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import DistributorCard from './distributor-card/DistributorCard';
import DistributorEditWizard from './distributor-edit-wizard/DistributorEditWizard';
import { useNavigate } from 'react-router-dom';
dayjs.extend(utc);

const Container = styled.div`
  width: 100%;
`;

const DialogContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
`;

const NotDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 600;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 16px;
  margin: 20px 25px;
  width: 100%;
  height: 100%;
  align-items: stretch;

  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 650px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

const Block = styled.div`
  margin: 2px 0 2px 0;
`;

const Span = styled.span`
  font-size: 14px;
  font-weight: 400;
`;

const OwnerName = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0%;
  color: #0088cc;
`;

const DistributorMapping = () => {
  const navigate = useNavigate();

  const [expenses, setExpenses] = useState([]);
  const [mappingList, setMappingList] = useState([]);
  const [selectedExpense, setSelectedExpense] = useState();
  const [selectedMonth, setSelectedMonth] = useState();
  const [selectedExpenseOwner, setSelectedExpenseOwner] = useState();
  const [selectedEventOwner, setSelectedEventOwner] = useState();
  const [eventTypes, setEventTypes] = useState([]);
  const [eventType, setEventType] = useState();
  const [eventAmount, setEventAmount] = useState();
  const [approvedAmount, setApprovedAmount] = useState();
  const [remarks, setRemarks] = useState();
  const [date, setDate] = useState();
  const [eventTypeName, setEventTypeName] = useState();
  const [expenseEvent, setExpenseEvent] = useState();
  const [expenseEventName, setExpenseEventName] = useState();
  const [expenseSfid, setExpenseSfid] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialog2, setOpenDialog2] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({});
  const [searchField, setSearchField] = useState('');
  const [activeTab, setActiveTab] = useState(0);
  const [editRecord, setEditRecord] = useState(null);

  const [pageNumber, setPageNumber] = useState(1);
  const [isFetch, setIsFetch] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [spinLoading, setSpinLoading] = useState(false);

  const loaderRef = useRef(null);
  const firstRun = useRef(true);
  const timerId = useRef();
  const timerLoadingId = useRef();
  const skipPageEffect = useRef(false);

  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false;
      return;
    }

    const delay = 1000;
    clearTimeout(timerId.current);
    timerId.current = setTimeout(() => {
      distributorMappingList();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, delay);

    return () => clearTimeout(timerId.current);
  }, [searchField]);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !spinLoading && hasMore) {
        setPageNumber((prev) => prev + 1);
      }
    });

    const currentLoader = loaderRef.current;
    if (currentLoader) {
      observer.observe(currentLoader);
    }

    return () => {
      if (currentLoader) observer.unobserve(currentLoader);
    };
  }, [spinLoading, hasMore]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('storedUserData'));
    if (user) {
      setUser(user);
    } else {
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    if (skipPageEffect.current) {
      skipPageEffect.current = false;
      return;
    }

    if (pageNumber === 1 && isFetch) {
      return;
    }

    distributorMappingList();
  }, [pageNumber]);

  const handleInputChange = (e) => {
    const approvedAmount =
      typeof Number(e.target.value) === 'number' ? +e.target.value : 0;
    if (approvedAmount <= eventAmount) {
      setApprovedAmount(+e.target.value);
    } else {
      return;
    }
  };

  const handleRemarksChange = (e) => {
    setRemarks(e.target.value);
  };

  const distributorMappingList = async (pageOverride, tabOverride) => {
    const page = pageOverride ?? pageNumber;
    const isApprovalsTab = (tabOverride ?? activeTab) === 1;
    try {
      if (page === 1) {
        setIsFetch(false);
      } else if (spinLoading) {
        return;
      }

      if (page === 1) {
        setLoading(true);
      }
      setSpinLoading(true);
      const result = await window.Platform.database.getDistributorMappingList({
        searchField,
        pageNumber: page,
        Approvals: isApprovalsTab,
      });

      if (result.data?.length < 20) {
        setHasMore(false);
      }

      if (page === 1) {
        setMappingList(result.data);
      } else {
        setMappingList((prev) => [...prev, ...result.data]);
      }

      setLoading(false);
      setSpinLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      setSpinLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    e.preventDefault();
    const serchItem = e.currentTarget.value;

    if (serchItem) {
      setIsFetch(true);
      setSearchField(serchItem);
    } else {
      setSearchField('');
      setIsFetch(false);
      clearTimeout(timerLoadingId.current);
    }

    setPageNumber(1);
  };

  const handleClose = () => {
    setOpenDialog(false);
    setEventType(null);
    setEventAmount(null);
    setDate(null);
    setEventTypeName(null);
    setExpenseEvent(null);
    setImageUrl(null);
  };

  const validateForm = (data) => {
    const errors = {};

    if (!Number(data['approved_amount__c'])) {
      errors['approved_amount__c'] = 'Amount cannot be zero or empty.';
    }

    return errors;
  };

  const handleSubmit = async () => {
    setLoading(true);
    const payload = {
      eventType: eventType?.eventName,
      Formated_Event_Name__c: `${
        expenseEventName
          ? eventTypeName + '(' + expenseEventName + ')'
          : eventTypeName
      }`,
      eventId: selectedExpense?.eventsfid,
      Amount__c: eventAmount,
      approved_amount__c: approvedAmount,
      date__c: selectedExpense.date__c,
      files__c: imageUrl?.url ? imageUrl?.url : selectedExpense?.upload_file__c,
      expenseSfid: expenseSfid,
      remarks,
    };

    try {
      const errors = validateForm(payload);
      setErrors(errors);

      if (Object.keys(errors).length === 0) {
        const result = await window.Platform.database.updateExpenseById(
          payload
        );
        if (result.hasError) {
          window.NotificationUtils.showError(result.message);
          throw new Error(`Update expense failed.`);
        }

        window.NotificationUtils.showSuccess(
          `Expense has been updated successfully`
        );
        setEventType(null);
        setEventAmount(null);
        setApprovedAmount(null);
        setDate(null);
        setEventTypeName(null);
        setRemarks(null);
        setExpenseEvent(null);
        setImageUrl(null);
        setOpenDialog(false);

        const result2 = await window.Platform.database.approvalExpenseList({
          monthName: selectedMonth,
          expenseOwnerSfid: selectedExpenseOwner?.sfid
            ? selectedExpenseOwner?.sfid
            : '',
          eventOwnerSfid: selectedEventOwner?.sfid
            ? selectedEventOwner?.sfid
            : '',
        });
        setExpenses(result2.data);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error during form submission:', error);
      setLoading(false);
      alert(`${error.message}`);
    }
  };

  const handleLoading = () => {
    // const delay = 500;
    // clearTimeout(timerLoadingId.current);
    // timerLoadingId.current = setTimeout(() => {
    //   setLoading(true);
    // }, delay);
  };

  // "Pending Approvals" is a server-side view: the backend returns only the
  // records awaiting the current user's action (VP -> "Approved by L2") when
  // the request is sent with Approvals: true. Shown only for VP profiles.
  const canApprove = user?.profile__c === 'VP';

  const handleTabChange = (event, newValue) => {
    if (newValue === activeTab) return;
    setActiveTab(newValue);
    setHasMore(true);
    setMappingList([]);
    // Reset to page 1 for the new tab. If we were already on page 1, the
    // pageNumber effect won't re-fire, so fetch explicitly; otherwise let the
    // pageNumber effect drive the fetch (guarded to avoid a duplicate call).
    if (pageNumber !== 1) {
      skipPageEffect.current = true;
      setPageNumber(1);
    }
    distributorMappingList(1, newValue);
  };

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        backgroundColor: '#F6F6F6',
        minHeight: '100vh',
      }}
    >
      <Sidebar />
      <Container>
        {loading && <OpaqueLoading />}
        <CustomHeader name='distributor-mapping' />
        <Box
          p={4}
          pb={2}
          style={{
            position: 'sticky',
            top: '60px',
            backgroundColor: '#F6F6F6',
            zIndex: 99,
          }}
        >
          <Box
            style={{ width: '100%' }}
            display='flex'
            flexDirection='row'
            flexWrap='wrap'
            alignItems='baseline'
            justifyContent='space-between'
            gap='10px'
          >
            <FlexContainer
              style={{ flexWrap: 'wrap', justifyContent: 'flex-start' }}
            >
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                textColor='primary'
                indicatorColor='primary'
                sx={{
                  '& .MuiTab-root': {
                    textTransform: 'none',
                    fontSize: '18px',
                    fontWeight: 600,
                  },
                }}
              >
                <Tab label='Distributor Mapping List' />
                {canApprove && <Tab label='Pending Approvals' />}
              </Tabs>
            </FlexContainer>
            <FlexContainer
              style={{ flexWrap: 'wrap', justifyContent: 'flex-start' }}
            >
              <TextField
                id='searchField'
                name='searchField'
                label='Search'
                variant='outlined'
                onChange={handleSearchChange}
                onKeyDown={handleLoading}
                placeholder='Search...'
                style={{ width: '300px', marginRight: 10 }}
              />
            </FlexContainer>
          </Box>
        </Box>

        {mappingList?.length > 0 ? (
          <Grid container spacing={2} padding={2} pt={0}>
            <GridContainer>
              {mappingList.map((mapObj, index) => {
                const isMappingListTab = activeTab === 0;
                // Logged-in user's sfid — read defensively so it works whether
                // storedUserData is flat (userDetails) or nested ({data:{...}}).
                const loginSfid = user?.sfid ?? user?.data?.userDetails?.sfid;
                const isOwnRecord =
                  !!loginSfid && mapObj?.owner__c === loginSfid;
                const isApprovedByL2 =
                  mapObj?.distributor_approval_status__c === 'Approved by L2';
                // VP only. On the Distributor Mapping List tab, show Edit when
                // EITHER the logged-in user's sfid matches the record owner
                // (owner__c) OR the record is "Approved by L2".
                // Pending Approvals tab is unchanged (always shown).
                const rowShowEdit =
                  canApprove &&
                  (isMappingListTab ? isOwnRecord || isApprovedByL2 : true);
                return (
                  <DistributorCard
                    style={{ cursor: 'pointer' }}
                    key={mapObj.sfid ?? mapObj.heroku_id__c ?? index}
                    mapObj={mapObj}
                    showEdit={rowShowEdit}
                    onEdit={(record) => setEditRecord(record)}
                    onClick={(e) => {
                      if (e.target.closest('.no-nav')) return;
                      navigate('/distributor-overview', { state: mapObj });
                    }}
                  />
                );
              })}
            </GridContainer>
          </Grid>
        ) : (
          <NotDiv>No Data Found</NotDiv>
        )}

        <Dialog
          open={openDialog}
          onClose={handleClose}
          sx={{
            '& .MuiPaper-root.MuiDialog-paper': {
              borderRadius: '16px',
              padding: '24px',
              boxShadow:
                'rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px',
              width: '600px',
            },
            '& .MuiBackdrop-root': {
              backgroundColor: 'transparent',
              backdropFilter: 'blur(1px)',
            },
          }}
        >
          <DialogTitle>
            <IconButton
              onClick={handleClose}
              style={{ position: 'absolute', top: 8, right: 8 }}
            >
              <GridCloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent style={{ paddingTop: '5px' }}>
            <DialogContainer>
              <FormControl fullWidth>
                <InputLabel id='select-label'>Event Type</InputLabel>
                <Select
                  sx={{ borderRadius: '10px' }}
                  labelId='select-label'
                  label='Event Type'
                  value={eventType}
                  disabled
                  required
                  error={Boolean(errors.eventType)}
                >
                  {eventTypes.map((item) => (
                    <MenuItem
                      name={item.mainEventName}
                      value={item}
                      key={item?.mainEventName}
                    >
                      {item.mainEventName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id='select-label'>Event ID</InputLabel>
                <Select
                  sx={{ borderRadius: '10px' }}
                  labelId='select-label'
                  label='Event ID'
                  value={selectedExpense?.eventsfid}
                  disabled
                  InputLabelProps={{
                    shrink: selectedExpense?.eventsfid,
                  }}
                  // required
                  // error={Boolean(errors.eventId)}
                >
                  <MenuItem value={selectedExpense?.eventsfid}>
                    {selectedExpense?.formated_event_name__c}
                    {/* (
                    {selectedExpense?.eventsfid}) */}
                  </MenuItem>
                </Select>
              </FormControl>
              <Box>
                <Block>
                  <Span>Event Owner: </Span>
                  <OwnerName>
                    {selectedExpense?.event_owner_name}-
                    {selectedExpense?.territoryname}
                  </OwnerName>
                </Block>
              </Box>
              <TextField
                sx={{ width: '100%', borderRadius: '10px' }}
                id='field-input'
                label={`Event Amount`}
                variant='outlined'
                value={eventAmount}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                slotProps={{
                  textField: {
                    sx: {
                      borderRadius: '10px',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                      },
                    },
                  },
                }}
              />

              <TextField
                sx={{ width: '100%', borderRadius: '10px' }}
                id='field-input'
                label={`Current Approved Amount`}
                variant='outlined'
                value={approvedAmount}
                onInput={(e) => {
                  // Restrict to numbers only
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={handleInputChange}
                required
                error={Boolean(errors.approved_amount__c)}
                slotProps={{
                  textField: {
                    sx: {
                      borderRadius: '10px',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                      },
                    },
                  },
                }}
              />

              {selectedExpense?.profile__c === 'SI' &&
                selectedExpense?.rm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`RM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.rm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'AM' &&
                selectedExpense?.rm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`RM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.rm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'SI' &&
                selectedExpense?.rmm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`RMM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.rmm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'AM' &&
                selectedExpense?.rmm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`RMM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.rmm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'SI' &&
                selectedExpense?.zm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`ZM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.zm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'AM' &&
                selectedExpense?.zm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`ZM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.zm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'RM' &&
                selectedExpense?.zm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`ZM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.zm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'RM' &&
                selectedExpense?.vp_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`VP Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.vp_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'RM' &&
                selectedExpense?.sfdc_level1_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`SFDC Level 1 Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.sfdc_level1_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'RMM' &&
                selectedExpense?.sfdc_level1_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`SFDC Level 1 (Amit Joshi) Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.sfdc_level1_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'ZM' &&
                selectedExpense?.sfdc_level2_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`SFDC Level 1 (Sood Sir) Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.sfdc_level2_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label='Date'
                  value={
                    selectedExpense?.date__c
                      ? dayjs(selectedExpense?.date__c, 'DD-MM-YYYY')
                      : null
                  }
                  format='YYYY-MM-DD'
                  disabled
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      sx: {
                        width: '100%',
                        borderRadius: '10px',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '10px',
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>

              <div style={{ position: 'relative', width: '100%' }}>
                <TextField
                  sx={{ width: '100%', borderRadius: '10px' }}
                  id='field-input-image'
                  variant='outlined'
                  value={
                    !imageUrl || imageUrl === 'undefined' || imageUrl === 'null'
                      ? 'Image is not available'
                      : imageUrl
                  }
                  disabled
                  slotProps={{
                    textField: {
                      sx: {
                        borderRadius: '10px',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '10px',
                        },
                      },
                    },
                  }}
                />
                {/* <img
                  style={{
                    position: 'absolute',
                    right: 0,
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: '#FFF',
                  }}
                  src={plusIcon}
                  alt='File Upload'
                  width={20}
                  height={20}
                /> */}
                {/* <VisibilityIcon
                  sx={{
                    position: 'absolute',
                    right: 0,
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: '#FFF',
                    color:
                      !imageUrl ||
                      imageUrl === 'undefined' ||
                      imageUrl === 'null'
                        ? 'grey.400'
                        : 'primary.main',
                    pointerEvents:
                      !imageUrl ||
                      imageUrl === 'undefined' ||
                      imageUrl === 'null'
                        ? 'none'
                        : 'auto',
                    '&:hover': {
                      cursor:
                        !imageUrl ||
                        imageUrl === 'undefined' ||
                        imageUrl === 'null'
                          ? 'default'
                          : 'pointer',
                    },
                  }}
                  onClick={() => {
                    if (
                      imageUrl &&
                      imageUrl !== 'undefined' &&
                      imageUrl !== 'null'
                    ) {
                      setOpenDialog2(true);
                    } else {
                      window.NotificationUtils?.showError?.(
                        'Image not available'
                      );
                    }
                  }}
                /> */}

                <Dialog
                  open={openDialog2}
                  onClose={() => setOpenDialog2(false)}
                  maxWidth='md'
                  fullWidth
                >
                  <DialogTitle>Preview</DialogTitle>
                  <DialogContent dividers>
                    {imageUrl?.toLowerCase().endsWith('.pdf') ? (
                      <iframe
                        src={imageUrl}
                        title='PDF Preview'
                        style={{
                          width: '100%',
                          height: '80vh',
                          border: 'none',
                        }}
                      />
                    ) : (
                      <img
                        src={imageUrl}
                        alt='Preview'
                        style={{
                          maxWidth: '100%',
                          maxHeight: '80vh',
                          display: 'block',
                          margin: '0 auto',
                        }}
                      />
                    )}
                  </DialogContent>
                </Dialog>
              </div>
              <TextField
                sx={{ width: '100%', borderRadius: '10px' }}
                id='field-input'
                label={`Remarks`}
                variant='outlined'
                value={
                  remarks === 'null' || remarks === 'undefined' ? '' : remarks
                }
                InputLabelProps={{
                  shrink: remarks,
                }}
                onChange={handleRemarksChange}
                slotProps={{
                  textField: {
                    sx: {
                      borderRadius: '10px',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                      },
                    },
                  },
                }}
              />

              <FlexContainer
                style={{ justifyContent: 'center', width: '100%', gap: 30 }}
              >
                <Button variant='outlined' onClick={handleClose}>
                  Cancel
                </Button>
                <Button variant='contained' onClick={handleSubmit}>
                  Update
                </Button>
              </FlexContainer>
            </DialogContainer>
          </DialogContent>
        </Dialog>

        {editRecord && (
          <DistributorEditWizard
            open={Boolean(editRecord)}
            record={editRecord}
            onClose={() => setEditRecord(null)}
            onSaved={(patch) => {
              // Optimistically reflect a persisted edit in the list. The list
              // is served from the `distributor_data_mv` materialized view,
              // which only refreshes on a ~10-min cron, so a re-fetch would
              // still show stale data. Patch the matching row in place instead.
              setMappingList((list) =>
                list.map((row) =>
                  (editRecord?.heroku_id__c &&
                    row.heroku_id__c === editRecord.heroku_id__c) ||
                  (editRecord?.sfid && row.sfid === editRecord.sfid)
                    ? { ...row, ...patch }
                    : row
                )
              );
            }}
            onSuccess={() => {
              // Row already patched via onSaved; just close. Do NOT re-fetch —
              // the MV is stale and would clobber the optimistic update.
              setEditRecord(null);
            }}
          />
        )}

        <div ref={loaderRef} style={{ height: '50px' }} />

        {spinLoading && pageNumber > 1 && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              padding: '20px',
            }}
          >
            <CircularProgress />
          </div>
        )}
      </Container>
    </div>
  );
};

export default DistributorMapping;
